import React from 'react'

const Moon = (props) => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x={0}
        y={0}
        viewBox="0 0 400 400"
        style={{
        enableBackground: "new 0 0 400 400",
        }}
        xmlSpace="preserve"
        {...props}
    >
        <path
        className="st0"
        d="M308.1 277.6c-50 33.9-119.3 20.9-154.1-28.5S130.4 130 179.2 94.4c3.1-2.3 4.4-6.4 3-10-1.4-3.6-5-5.9-8.9-5.5-24.6 2.6-48.2 11.5-68.4 25.7-65.8 46.3-81.3 137.9-35.1 203.7 46.3 65.8 137.8 82.1 203.6 35.8 20.2-14.2 36.6-33.5 47.3-55.7 1.7-3.5.8-7.7-2.1-10.2-3-2.5-7.3-2.7-10.5-.6zM283.2 59.1c0 1.8-.7 3.5-1.9 4.7-1.2 1.2-2.8 1.9-4.7 1.9h-16.4v16.4c0 3.6-3 6.6-6.6 6.6-1.8 0-3.5-.7-4.7-1.9-1.2-1.2-1.9-2.8-1.9-4.7V65.7h-16.4c-3.6 0-6.6-2.9-6.6-6.6 0-1.8.7-3.5 1.9-4.7s2.8-1.9 4.7-1.9H247V36.1c0-3.6 3-6.6 6.6-6.6 1.8 0 3.5.7 4.7 1.9 1.2 1.2 1.9 2.8 1.9 4.7v16.4h16.4c3.7 0 6.6 2.9 6.6 6.6z"
        />
        <path
        className="st0"
        d="M259.5 163.1c0 1.8-.7 3.5-1.9 4.7-1.2 1.2-2.8 1.9-4.7 1.9h-16.4v16.4c0 3.6-3 6.6-6.6 6.6-1.8 0-3.5-.7-4.7-1.9-1.2-1.2-1.9-2.8-1.9-4.7v-16.4h-16.4c-3.6 0-6.6-2.9-6.6-6.6 0-1.8.7-3.5 1.9-4.7 1.2-1.2 2.8-1.9 4.7-1.9h16.4V140c0-3.6 3-6.6 6.6-6.6 1.8 0 3.5.7 4.7 1.9s1.9 2.8 1.9 4.7v16.4h16.4c3.7.1 6.6 3 6.6 6.7zm97.3-29.7c0 1.8-.7 3.5-1.9 4.7-1.2 1.2-2.8 1.9-4.7 1.9h-16.4v16.4c0 3.6-3 6.6-6.6 6.6-1.8 0-3.5-.7-4.7-1.9-1.2-1.2-1.9-2.8-1.9-4.7V140h-16.4c-3.6 0-6.6-3-6.6-6.6 0-1.8.7-3.5 1.9-4.7 1.2-1.2 2.8-1.9 4.7-1.9h16.4v-16.4c0-3.6 3-6.6 6.6-6.6 1.8 0 3.5.7 4.7 1.9 1.2 1.2 1.9 2.8 1.9 4.7v16.4h16.4c3.7 0 6.6 3 6.6 6.6z"
        />
    </svg>
)

export default Moon